"use strict";

// delete-documents
$(function () {
    // Envoie les ids des docs sélectionnés pour check les acls de suppression
    $("body").on("click", "#btn-delete-documents", function () {
        // Récupérer toutes les checkbox
        var $selected = $.map($("table.table-document tr").find("input:checkbox.checkbox-selected").filter(function (i, cb) {
            return $(cb).is(":checked");
        }), function (cb) {
            return $(cb).val();
        });
        //Envoi ajax à l'action DeleteDocumentsModal
        $.ajax({
            url: "/Affaires/DeleteDocumentsModal",
            type: "post",
            data: {
                ids: $selected
            },
            success: function success(data) {
                $(".modal-body").html(data);
                if (!$("#IdToDelete")) {
                    $("#btnSubmitDeleteDocs").addClass("d-none");
                }
            }
        });
    });
    // Envoie les docs à l'action de suppression
    $("body").on("click", "#btnSubmitDeleteDocs", function () {
        $("#btnSubmitDeleteDocs, #btnCancelDeleteDocs").attr("disabled", "disabled");
        // Récupérer toutes les checkbox
        var $form = $("#formDeleteDocs").serialize();
        var $spinner = $("#spinner");
        $spinner.append($('<i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>'));
        //Envoi ajax à l'action DeleteDocumentsModal
        $.ajax({
            url: "/Affaires/DeleteDocuments",
            type: "post",
            data: $form,
            success: function success() {
                document.location.reload(true);
            }
        });
    });
});
// share-documents
$.fn.initShareDocumentModal = function () {
    var $target = $(this),
        $selected = $.map($("table.table-document tr").find("input:checkbox.checkbox-selected").filter(function (i, cb) {
        return $(cb).is(":checked");
    }), function (cb) {
        return $(cb).val();
    });
    $target.find("input:hidden#publicids").val($selected.join(","));
    return $target;
};
// Au sur le bouton de génération des liens de partage de documents
$.fn.initShareDocumentLinks = function (urlAction) {
    $.ajax({
        url: urlAction,
        data: {
            publicIds: $('#publicids').val(),
            nbreJours: $('#NbreJours').val()
        },
        type: 'POST',
        success: function success(data) {
            $('#generated-share-links').html(data);
            // Ajoute un bouton pour copier le lien de téléchargement après chaque lien
            $(".download-link").each(function () {
                var link = $(this).find('a').attr('href');
                var clipboardElement = $("<i class='cursor-hand mx-2 fa fa-copy' title='Copier le lien de téléchargement'></i>");
                clipboardElement.click(function () {
                    // Copie le lien dans le presse-papier
                    window.navigator['clipboard'].writeText(link);
                });
                $(this).append(clipboardElement);
            });
        }
    });
    return $(this);
};
$.fn.initShareDocumentInPreviewModal = function () {
    var $target = $(this),
        $previewShare = $(".preview-share");
    $target.on("click", ".btn-preview-share-documents", function () {
        $previewShare.toggleClass("d-none");
        if (!$previewShare.hasClass("d-none")) {
            $previewShare.find("input[name='Email']").focus();
        }
    }).off("click", ".preview-share button[type=submit]").on("click", ".preview-share button[type=submit]", function (e) {
        e.preventDefault();
        var $this = $(this),
            $form = $this.parents("form"),
            addMessage = function addMessage(divState, iconState, message) {
            var $message = $("<div class=\"alert alert-" + divState + "\">\n                        <i class=\"fa fa-" + iconState + "\" > </i>\n                        " + message + "\n                        <i class=\"fa fa-times cursor-hand float-right mt-1\" onclick=\"$(this).parent().remove();\"\n                        </div>");
            $message.insertBefore($("iframe"));
            setTimeout(function () {
                $message.remove();
            }, 10000);
        };
        if ($form.valid()) {
            $.ajax({
                type: $form.attr("method"),
                url: $form.attr("action"),
                data: $form.serialize()
            }).done(function (data) {
                $previewShare.toggleClass("d-none");
                $("input#Email").val("");
                addMessage("success", "success", "Le partage a bien été effectué !");
            }).fail(function (data) {
                addMessage("danger", "warning", "Le partage n'a pas pu être effectué.");
            });
        }
    });
    return $target;
};
// commun
$(function () {
    //CheckBox dans la page de document
    var $cbSelectedDocuments = $("input:checkbox.checkbox-selected"),
        $btnSelectedDocuments = $("a.selected-documents,button.selected-documents");
    $("body").on("change", "input:checkbox.checkbox-selected", function () {
        var nbreChecked = $cbSelectedDocuments.filter(function (i, cb) {
            return $(cb).is(":checked");
        }).length;
        if ($btnSelectedDocuments.is(":visible") && nbreChecked === 0) {
            $btnSelectedDocuments.addClass("d-none");
        } else if (!$btnSelectedDocuments.is(":visible") && nbreChecked > 0) {
            $btnSelectedDocuments.removeClass("d-none");
        }
        return true;
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Affaire/share-delete-document.ts
// module id = 599
// module chunks = 0